import React from "react";

const Alert = ({ children }) => {
  return (
    <div
      className="alert alert-danger"
      role="alert"
      style={{ position: "fixed", width: "98%", marginTop: "10px" }}
    >
      {children}
    </div>
  );
};

export default Alert;
